// platform
import { useEffect } from 'react';
import { atomWithImmer } from 'jotai-immer';
import { useAtom } from 'jotai';

// app
import sessionRepo from '../../../core/repo/sessionRepo';
import { ngDelegate, ngContext } from '../../../core/services/ng.delegate';

// types
import { Purl, ApiLogData, ApiLogStore } from './types';

// STORE DATA
const apiLogAtom = atomWithImmer<ApiLogData>(storeDataVM());
function storeDataVM(): ApiLogData {
    return {
        items: [],
        isOn: false,
    };
}

// STORE HOOK
const useApiLogStore = (): ApiLogStore => {
    const [store, setStore] = useAtom(apiLogAtom);

    // INIT
    useEffect(() => {
        console.log('API STORE: INIT');

        setStore(draft => {
            draft.isOn = ngContext().apiLog;
        });

        // destroy
        return (): void => {
            console.log('API STORE: DESTROY with items: ' + store.items.length);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // DEFINITION
    return {
        isOn: store.isOn,
        items: store.items,
        setList,
        toggle,
        unload,
    };

    function setList(): void {
        // load api log from local storage
        const getLog = sessionRepo.getLocalStoreKey('apilog');
        const log: Purl[] = Array.isArray(getLog) ? getLog : [];

        console.log('API LOG: GET LIST: ' + log.length);
        setStore(draft => {
            draft.items = log;
        });
    }

    function toggle(): void {
        // always reset log on toggle
        sessionRepo.setLocalStoreKey('apilog', []);

        const isOn = !store.isOn;
        console.log('api store toggle, state now is: ' + store.isOn);
        ngDelegate.rootScopeUpdate('apiLog', isOn);

        setStore(draft => {
            draft.items = [];
            draft.isOn = isOn;
        });
    }

    // UNLOAD
    function unload(): void {
        console.log('API STORE: UNLOAD: ' + store.items.length);
        setStore(() => storeDataVM()); // hard reset, do not use draft
    }
};

export default useApiLogStore;
